(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-blog"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const loadMoreBtn = document.getElementById('load-more-btn');
  if (!loadMoreBtn) return;

  loadMoreBtn.addEventListener('click', function () {
    const url = this.getAttribute('data-next-url');
    const grid = document.getElementById('blog-grid');

    this.disabled = true;
    this.textContent = 'Loading...';

    fetch(url + '?section_id={{ section.id }}')
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const newArticles = doc.querySelectorAll('#blog-grid .blog-grid-item');
        newArticles.forEach(article => grid.appendChild(article));

        const newBtn = doc.querySelector('#load-more-btn');
        if (newBtn) {
          loadMoreBtn.setAttribute('data-next-url', newBtn.getAttribute('data-next-url'));
          loadMoreBtn.disabled = false;
          loadMoreBtn.textContent = 'Load More';
        } else {
          loadMoreBtn.remove();
        }
      })
      .catch(err => {
        console.error('Load more failed', err);
        loadMoreBtn.disabled = false;
        loadMoreBtn.textContent = 'Load More';
      });
  });
});

  } catch(e) { console.error(e); }
})();
})();
